import type { SupportContextJson } from '../types/support.types';
import { getConsoleLogs } from './console-logger';
import { getNetworkLogs } from './network-logger';

export function formatViewport(viewport: SupportContextJson['viewport']): string {
  return typeof viewport === 'string' ? viewport : `${viewport.width}x${viewport.height}`;
}

/**
 * Собирает автоконтекст текущей страницы для обращения.
 */
export function collectSupportContext(): SupportContextJson {
  return {
    url: window.location.href,
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight },
    timestamp: new Date().toISOString(),
  };
}

/**
 * Собирает логи консоли и сети для обращения.
 */
export function collectSupportLogs(): {
  console_logs: Array<{ level: string; message: string; timestamp: string }>;
  network_logs: Array<{ method: string; url: string; status: number; duration_ms: number | null }>;
} {
  return {
    console_logs: getConsoleLogs().slice(-50).map(e => ({
      level: e.level,
      message: e.message,
      timestamp: e.timestamp,
    })),
    network_logs: getNetworkLogs()
      .filter(e => e.status !== null && e.status >= 400)
      .slice(-20)
      .map(e => ({
        method: e.method,
        url: e.url,
        status: e.status!,
        duration_ms: e.duration,
      })),
  };
}
